// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__CQuRh","col":"styles_col__Hw876"};